// Des icônes dessinées, pas des émojis.
//
// Les caractères ☀ ☾ ⚽ 🛡 🟨 sont rendus par la police EMOJI du système : sur iOS ils
// arrivent en couleur, avec leur propre graisse et leur propre alignement vertical,
// et ils jurent au milieu d'une interface au trait. Ils ne suivent ni la couleur du
// thème ni l'épaisseur du reste. Dessinés, ils prennent `currentColor` et se taisent.

const base = (t) => ({
  width: t, height: t, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round',
  'aria-hidden': true, focusable: false,
});

export const Soleil = ({ t = 18 }) => (
  <svg {...base(t)}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

export const Lune = ({ t = 18 }) => (
  <svg {...base(t)}>
    {/* Un croissant par soustraction visuelle : l'arc unique reste net à 16 px là où
        deux cercles superposés se remplissent de bouillie. */}
    <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a7 7 0 1 0 10.5 10.5Z" />
  </svg>
);

export const Ballon = ({ t = 18 }) => (
  <svg {...base(t)}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.2l3.2 2.3-1.2 3.7h-4l-1.2-3.7z" fill="currentColor" stroke="none" />
    <path d="M12 3.5v3.7M19.6 9.6l-3.6 0M16.2 19.4l-2.2-3M7.8 19.4l2.2-3M4.4 9.6l3.6 0" strokeWidth="1.5" />
  </svg>
);

export const Bouclier = ({ t = 18 }) => (
  <svg {...base(t)}>
    <path d="M12 3l7 2.6v5.6c0 4-3.1 6.6-7 8.8-3.9-2.2-7-4.8-7-8.8V5.6z" />
  </svg>
);

export const Inverser = ({ t = 18 }) => (
  <svg {...base(t)}>
    <path d="M8 4v16M8 4L5 7M8 4l3 3M16 20V4M16 20l-3-3M16 20l3-3" />
  </svg>
);

/**
 * Le journal du match : une CHRONOLOGIE, pas un menu.
 *
 * Trois traits horizontaux disent « liste » ou « menu » — c'est le hamburger, et
 * l'œil y lit une navigation. Une ligne de temps jalonnée dit ce que le bouton ouvre :
 * ce qui s'est passé, dans l'ordre, à la minute près.
 */
export const Journal = ({ t = 18 }) => (
  <svg {...base(t)}>
    <path d="M7 3v18" />
    <circle cx="7" cy="7" r="2.1" fill="currentColor" stroke="none" />
    <circle cx="7" cy="13" r="2.1" fill="currentColor" stroke="none" />
    <circle cx="7" cy="19" r="2.1" fill="currentColor" stroke="none" />
    <path d="M12 7h8M12 13h6M12 19h8" strokeWidth="1.7" />
  </svg>
);

/** Le carton : un rectangle incliné, rempli de sa couleur, sans contour au trait. */
export const Carton = ({ t = 18, couleur = 'var(--warn)' }) => (
  <svg {...base(t)} stroke="none">
    <rect x="7" y="3.5" width="10" height="15" rx="1.8" fill={couleur} transform="rotate(12 12 11)" />
  </svg>
);

export const Fleche = ({ t = 18 }) => (
  <svg {...base(t)}>
    <path d="M5 19L19 5M19 5h-7M19 5v7" />
  </svg>
);

/** Ballon minuscule (pastille de jeton) : à 11 px, les coutures ne sont que du bruit. */
export const BallonPlein = ({ t = 11 }) => (
  <svg width={t} height={t} viewBox="0 0 24 24" aria-hidden focusable="false">
    <circle cx="12" cy="12" r="9" fill="currentColor" />
    <path d="M12 6.5l3.8 2.8-1.5 4.5H9.7L8.2 9.3z" fill="var(--bg)" />
  </svg>
);

/** Passe décisive : la flèche qui amène au but, pas un caractère de police. */
export const Passe = ({ t = 12 }) => (
  <svg {...base(t)} strokeWidth="2.4">
    <path d="M4 16c3-6 8-9 15-9" />
    <path d="M13 4.5L19 7l-2.4 6" />
  </svg>
);

export const Entree = ({ t = 11 }) => (
  <svg {...base(t)} strokeWidth="2.6">
    <path d="M12 20V5M12 5l-5 5M12 5l5 5" />
  </svg>
);

export const Rafraichir = ({ t = 16 }) => (
  <svg {...base(t)}>
    <path d="M20 12a8 8 0 1 1-2.3-5.6" />
    <path d="M20 4v4.5h-4.5" />
  </svg>
);

export const Vers = ({ t = 14 }) => (
  <svg {...base(t)}>
    <path d="M4 12h15M14 7l5 5-5 5" />
  </svg>
);

export const Crayon = ({ t = 14 }) => (
  <svg {...base(t)}>
    <path d="M4 20h4L19 9a2.5 2.5 0 0 0-3.5-3.5L4.5 16.5z" />
    <path d="M14.5 6.5L17.5 9.5" />
  </svg>
);

export const Pause = ({ t = 13 }) => (
  <svg {...base(t)} stroke="none">
    <rect x="7" y="5" width="3.6" height="14" rx="1.2" fill="currentColor" />
    <rect x="13.4" y="5" width="3.6" height="14" rx="1.2" fill="currentColor" />
  </svg>
);

export const Lecture = ({ t = 13 }) => (
  <svg {...base(t)} stroke="none">
    <path d="M8 5.5l11 6.5-11 6.5z" fill="currentColor" />
  </svg>
);

/** But encaissé : le ballon barré, et non un « +1 » qui ne dit pas de quel côté. */
export const ButAdverse = ({ t = 17 }) => (
  <svg {...base(t)}>
    <circle cx="12" cy="12" r="8" />
    <path d="M5 19L19 5" strokeWidth="2.2" />
  </svg>
);

export const MiTemps = ({ t = 16 }) => (
  <svg {...base(t)}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 12V7M12 12h4" />
  </svg>
);
